<template>
  <el-table
    ref="table"
    v-loading="loading"
    element-loading-text="Loading"
    :data="tableData"
    border
    fit
    highlight-current-row
    tooltip-effect="dark"
    style="width: 100%"
    @sort-change="handleSortChange"
    @selection-change="handleSelectionChange"
  >
    <!-- <div v-for="(item) in tableLabel"  :key="item.label">
            <el-table-column v-if="item.type" :type="item.type?item.type:''" :fixed="item.fixed?item.fixed:false"></el-table-column>
            <el-table-column v-else :width="item.width ? item.width : ''" :fixed="item.fixed?item.fixed:false"  :align="item.align" :label="item.label" :prop="item.param" :sortable="item.sortable ? 'custom' : false">
                   <template slot-scope="scope">
                       <slot v-if="item.slot" :scope="scope" :name="item.slot"></slot>
                       <div v-html="item.render(scope.row)" v-else-if="item.render"> -->
    <!-- {{item.render(scope.row)}} -->
    <!-- </div>
                      <span v-else>{{scope.row[item.param]}} {{item.type}}</span>
                  </template>
            </el-table-column>
        </div> -->
    <!--多选列-->
    <el-table-column
      v-if="selectionShow"
      type="selection"
      width="50"
      align="center"
      highlight-current-row
      fixed
    >
    </el-table-column>
    <el-table-column
      v-for="(item, index) in tableLabel"
      v-show="index == 1"
      :key="index"
      :width="item.width ? item.width : ''"
      :fixed="item.fixed ? item.fixed : false"
      :type="item.type ? item.type : ''"
      :align="item.align"
      :label="item.label"
      :prop="item.param"
      :sortable="item.sortable ? 'custom' : false"
      :show-overflow-tooltip="item.tooltip ? item.tooltip : false"
    >
      <template slot-scope="scope">
        <slot v-if="item.slot" :scope="scope" :name="item.slot">
          <span v-show="scope.row[item.param].isBatch">{{
            scope.row[item.param].attributeValue +
            scope.row[item.param].unitValue
          }}</span>
          <el-input
            v-show="!scope.row[item.param].isBatch"
            v-model="scope.row[item.param].val"
            @focus="
              handleInput(
                scope.$index,
                scope.row[item.param].attributeId,
                scope.row[item.param].attributeName
              )
            "
          ></el-input>
          <!-- <el-input v-show="item.isProduct?item.isProduct:false" v-model="scope.row[item.param].val" @focus="handleInput(scope.$index,scope.row[item.param].attributeId,scope.row[item.param].attributeName)"></el-input> -->
        </slot>
        <div v-else-if="item.render" v-html="item.render(scope.row)"></div>
        <span v-else>{{ scope.row[item.param] }} {{ item.type }}</span>
      </template>
    </el-table-column>

    <el-table-column
      v-if="tableOption.label"
      :width="tableOption.width"
      :label="tableOption.label"
      align="center"
      class-name="small-padding fixed-width"
      :fixed="tableOption.fixed ? tableOption.fixed : false"
    >
      <template slot-scope="scope">
        <template v-if="tableOption.permission == '1'">
          <el-button
            v-for="(item, index) in tableOption.options"
            :key="index"
            v-permission="[item.permission]"
            :type="item.type"
            :icon="item.icon"
            size="mini"
            :disabled="item.disabled"
            @click="handleButton(item.methods, scope.row, scope.row)"
          >
            {{ item.label }}
          </el-button>
        </template>
        <template v-if="tableOption.permission == '0'">
          <el-button
            v-for="(item, index) in tableOption.options"
            :key="index"
            :type="item.type"
            :icon="item.icon"
            size="mini"
            :disabled="item.disabled"
            @click="handleButton(item.methods, scope.row, scope.row)"
          >
            {{ item.label }}
          </el-button>
        </template>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
export default {
  components: {},
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    tableData: {
      type: Array,
      default: () => {
        return [];
      },
    },
    tableLabel: {
      type: Array,
      default: () => {
        return [];
      },
    },
    tableOption: {
      type: Object,
      default: () => {
        return {};
      },
    },
    selectionShow: {
      type: Boolean,
      default: false,
    },
    radioShow: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleButton(methods, row, index) {
      // 按钮事件
      this.$emit('handleButton', {
        methods,
        row,
        index,
      });
    },
    handleSortChange(val) {
      // 排序
      this.$emit('handleSortChange', val);
    },
    handleSelectionChange(val) {
      this.$emit('handleSelectionChange', val);
    },
    handleInput(index, val, standardName) {
      this.$emit('handleInput', {
        index,
        val,
        standardName,
      });
    },
  },
};
</script>

<style scoped lang="scss">
.operate {
  display: flex;
  justify-content: center;
  align-items: center;
  div {
    margin-right: 10px;
    color: #0064c8;
    cursor: pointer;
    border-bottom: 1px solid transparent;
    &:hover {
      border-bottom: 1px solid #0064c8;
    }
  }
}
</style>
